import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import { Loader2 } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      const from = loc.state?.from || "/dashboard";
      nav(from);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-md mx-auto px-5 lg:px-8 py-16">
        <div className="overline mb-3">WELCOME BACK</div>
        <h1 className="font-display text-4xl font-bold tracking-tight mb-2">Log in to GrantFlow</h1>
        <p className="text-neutral-600 mb-8">Chase funding, not paperwork.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="text-sm font-medium">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full h-11 border border-neutral-200 rounded-lg px-3 focus:outline-none focus:ring-2 focus:ring-neutral-900"
              placeholder="you@org.com" data-testid="login-email" autoComplete="email" />
          </div>
          <div>
            <label className="text-sm font-medium">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full h-11 border border-neutral-200 rounded-lg px-3 focus:outline-none focus:ring-2 focus:ring-neutral-900"
              placeholder="Your password" data-testid="login-password" autoComplete="current-password" />
          </div>
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">
            {loading && <Loader2 size={16} className="animate-spin" />} Log in
          </button>
        </form>
        <div className="mt-4 text-sm text-center">
          <Link to="/forgot-password" className="text-neutral-600 hover:text-neutral-900 underline" data-testid="login-forgot-link">Forgot password?</Link>
        </div>
        <div className="mt-6 text-sm text-neutral-600">
          No account? <Link to="/signup" className="underline font-medium" data-testid="login-to-signup">Create one — it's free</Link>
        </div>
      </div>
    </div>
  );
}
